import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const SavedIcon = ({
  width = 16,
  height = 16,
  stroke = '#16A34A',
  className
}: SVGComponentProps &
  Omit<React.SVGProps<SVGSVGElement>, keyof SVGComponentProps>) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_saved_icon)">
        <path
          d="M10.6673 5.3335V3.46683C10.6673 2.72009 10.6673 2.34672 10.522 2.06151C10.3942 1.81063 10.1902 1.60665 9.9393 1.47882C9.65409 1.3335 9.28072 1.3335 8.53398 1.3335H3.46732C2.72058 1.3335 2.34721 1.3335 2.062 1.47882C1.81111 1.60665 1.60714 1.81063 1.47931 2.06151C1.33398 2.34672 1.33398 2.72009 1.33398 3.46683V8.5335C1.33398 9.28023 1.33398 9.6536 1.47931 9.93882C1.60714 10.1897 1.81111 10.3937 2.062 10.5215C2.34721 10.6668 2.72058 10.6668 3.46732 10.6668H5.33398M8.00065 10.0002L9.33398 11.3335L12.334 8.3335M7.46732 14.6668H12.534C13.2807 14.6668 13.6541 14.6668 13.9393 14.5215C14.1902 14.3937 14.3942 14.1897 14.522 13.9388C14.6673 13.6536 14.6673 13.2802 14.6673 12.5335V7.46683C14.6673 6.72009 14.6673 6.34672 14.522 6.06151C14.3942 5.81063 14.1902 5.60665 13.9393 5.47882C13.6541 5.3335 13.2807 5.3335 12.534 5.3335H7.46732C6.72058 5.3335 6.34721 5.3335 6.062 5.47882C5.81111 5.60665 5.60714 5.81063 5.47931 6.06151C5.33398 6.34672 5.33398 6.72009 5.33398 7.46683V12.5335C5.33398 13.2802 5.33398 13.6536 5.47931 13.9388C5.60714 14.1897 5.81111 14.3937 6.062 14.5215C6.34721 14.6668 6.72058 14.6668 7.46732 14.6668Z"
          stroke={stroke}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_saved_icon">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { SavedIcon };
